import request from '@/utils/requestLongTime'
import requestNoToken from '@/utils/requestNoToken'
import Qs from 'qs'
export function payMent(userId,orderSn) {
  return request({
    url: '/index/payMent',
    method: 'get',
    params: {userId,orderSn}
  })
}



// WEBPACK FOOTER //
// ./src/api/payMent.js